import { useEffect } from 'react';

const useTypeAhead = ({ activeIndex, allOptions, filteredOptions, inputRef, options, popupOpen, onClose, onOpen, onHighlightChange, onInputChange, onChange, onKeyDown, onKeyUp, filterOptions, setActiveIndex, setFilteredOptions, setInputValue, setPopupOpen, }) => {
    //added this block to listen to options data change (especially for ajax based searches)
    useEffect(() => {
        var _a;
        const currentValue = (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.value;
        const newOptions = options.flatMap((option) => option.options);
        if (currentValue) {
            setFilteredOptions(filterOptions(currentValue, newOptions));
        }
        else {
            setFilteredOptions(newOptions);
        }
    }, [options]);
    //handles focus on search text field
    const handleFocus = () => {
        onOpen && popupOpen === false && onOpen();
        setPopupOpen(true);
    };
    //listens to click event on the search text field
    const handleItemClick = (option) => {
        onChange && onChange(option);
        const { label } = option;
        setInputValue(label);
        setPopupOpen(false);
        setFilteredOptions(filterOptions(label, allOptions));
    };
    //listens to input change event on the search text field
    const handleInputChange = (event) => {
        const newValue = event.target.value;
        setInputValue(newValue);
        setPopupOpen(true);
        onInputChange && onInputChange(newValue, event);
        setFilteredOptions(filterOptions(newValue, allOptions));
    };
    //custom event fired when keyup or click event is triggered
    const handleHighlightChange = (ref) => {
        onHighlightChange && onHighlightChange(ref);
    };
    //listens to keydown event on the search text field, provides keyboard support
    const handleKeyDown = (event) => {
        var _a;
        if (event.key === "Escape") {
            onClose && popupOpen && onClose();
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            setPopupOpen(false);
        }
        else if (event.key === "ArrowDown") {
            if (activeIndex < filteredOptions.length - 1)
                setActiveIndex(activeIndex + 1);
        }
        else if (event.key === "ArrowUp") {
            if (activeIndex > 0)
                setActiveIndex(activeIndex - 1);
        }
        else if (event.key === "Enter") {
            const optionClicked = filteredOptions[activeIndex];
            if (optionClicked) {
                setInputValue(optionClicked === null || optionClicked === void 0 ? void 0 : optionClicked.label);
            }
            setActiveIndex(-1);
            setFilteredOptions(filterOptions(optionClicked === null || optionClicked === void 0 ? void 0 : optionClicked.label, allOptions));
        }
        onKeyDown && onKeyDown(event);
    };
    //listens to keyup event on the search text field
    const handleKeyUp = (event) => {
        handleHighlightChange(inputRef);
        onKeyUp && onKeyUp(event);
    };
    return {
        handleFocus,
        handleInputChange,
        handleHighlightChange,
        handleKeyDown,
        handleKeyUp,
        handleItemClick,
    };
};

export { useTypeAhead };
//# sourceMappingURL=useTypeAhead.esm.js.map
